import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Chip } from "@mui/material";
import { useGetOne } from "react-admin";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
export var ContestItem = function (props) {
    var record = props.record;
    var aliasRenderer = useAliasRenderer();
    var data = useGetOne("sequent_backend_contest", { id: record }).data;
    return _jsx(_Fragment, { children: data ? _jsx(Chip, { label: aliasRenderer(data === null || data === void 0 ? void 0 : data.presentation) }) : null });
};
